module.exports = __webpack_public_path__ + "images/0489da2c37ed2f3d8a1d663dcf4da1da.svg";